import React from 'react'
import { useNavigate } from 'react-router-dom'

const Unauthorize = () => {
    const navigate = useNavigate()

    const handleGoToDashboard = () => {
        navigate('/')
    }

    return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f8f9fa',
          padding: '20px',
          textAlign: 'center'
        }}>
          <div style={{
            maxWidth: '600px',
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            padding: '40px',
            margin: '0 auto'
          }}>
            <div style={{
              fontSize: '80px',
              color: '#ffc107',
              marginBottom: '20px'
            }}>
              ⚠️
            </div>
            
            <h1 style={{
              fontSize: '32px',
              color: '#495057',
              marginBottom: '16px',
              fontWeight: '600'
            }}>
              Access Denied
            </h1>
            
            <p style={{
              fontSize: '18px',
              color: '#6c757d',
              marginBottom: '30px',
              lineHeight: '1.6'
            }}>
              You don't have permission to access this page. 
              Please contact your administrator if you believe this is an error.
            </p>
            
            <button
              onClick={handleGoToDashboard}
              style={{
                backgroundColor: '#0d6efd',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 28px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                boxShadow: '0 4px 6px rgba(13, 110, 253, 0.2)'
              }}
              // ✅ Use currentTarget (correctly typed as HTMLButtonElement)
              onMouseEnter={(e) => {
                const button = e.currentTarget
                button.style.backgroundColor = '#0b5ed7'
              }}
              onMouseLeave={(e) => {
                const button = e.currentTarget
                button.style.backgroundColor = '#0d6efd'
              }}
            >
              Back to Dashboard
            </button>
            
            <div style={{
              marginTop: '24px',
              fontSize: '14px',
              color: '#adb5bd'
            }}>
              Error Code: 403
            </div>
          </div>
        </div>
    )
}

export default Unauthorize